import { render, staticRenderFns } from "./AdminMain.vue?vue&type=template&id=e4f52468"
import script from "./AdminMain.vue?vue&type=script&lang=js"
export * from "./AdminMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports